import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import { ExternalLink, Loader2 } from "lucide-react";

const HUB_URL = "https://lead-nurture-hub-13.emergent.host";

export default function KiooCRMHub() {
  const [loading, setLoading] = useState(true);

  return (
    <>
      <Helmet>
        <title>Kioo CRM Hub | Kioo Radio 98.1 FM</title>
        <meta
          name="description"
          content="Kioo Radio CRM Hub – Lead nurture and outreach management for the Kioo Radio team."
        />
      </Helmet>

      <div
        data-testid="kioocrm-page"
        className="w-full bg-white"
        style={{ minHeight: "calc(100vh - 80px)" }}
      >
        {/* Slim utility bar */}
        <div
          data-testid="kioocrm-utility-bar"
          className="flex items-center justify-between px-4 py-2 border-b border-gray-200 bg-gray-50"
        >
          <div className="flex items-center gap-2 text-sm text-gray-700">
            <span className="font-semibold text-[#0c713d]">Kioo CRM Hub</span>
            <span className="hidden sm:inline text-gray-400">
              · Lead Nurture &amp; Outreach
            </span>
          </div>
          <a
            data-testid="kioocrm-open-in-new-tab"
            href={HUB_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1 text-sm text-[#0c713d] hover:underline"
          >
            Open in new tab
            <ExternalLink className="w-3.5 h-3.5" />
          </a>
        </div>

        {/* Iframe container */}
        <div
          className="relative w-full"
          style={{ height: "calc(100vh - 80px - 41px)" }}
        >
          {loading && (
            <div
              data-testid="kioocrm-loading"
              className="absolute inset-0 flex flex-col items-center justify-center bg-white z-10"
            >
              <Loader2 className="w-8 h-8 text-[#0c713d] animate-spin" />
              <p className="mt-3 text-sm text-gray-600">
                Loading Kioo CRM Hub…
              </p>
            </div>
          )}
          <iframe
            data-testid="kioocrm-iframe"
            src={HUB_URL}
            title="Kioo CRM Hub"
            onLoad={() => setLoading(false)}
            className="w-full h-full border-0"
            allow="clipboard-read; clipboard-write; fullscreen"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </>
  );
}
